import { createSvgIcon } from "@mui/material";

export const MarginTopIcon = createSvgIcon(
  <svg viewBox="0 0 11 12" fill="none">
    <g transform="rotate(-90 5.5 6)">
      <path
        fill="currentColor"
        d="M10.123.633A.625.625 0 0 0 9.49 0a.64.64 0 0 0-.633.633v10.234c0 .37.29.633.633.633a.61.61 0 0 0 .633-.633zM5.484 7.594H1.266V3.906h4.218zM6.75 3.906c0-.685-.554-1.265-1.266-1.265H1.266A1.28 1.28 0 0 0 0 3.906v3.688c0 .712.58 1.265 1.266 1.265h4.218A1.25 1.25 0 0 0 6.75 7.594z"
      />
    </g>
  </svg>,
  "MarginTopIcon",
);
